(() => {
  function init() {
    document.querySelectorAll('[data-kit-page]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('#kit-quantity');
      const clamp = value => Math.min(99, Math.max(1, parseInt(value, 10) || 1));
      root.querySelectorAll('[data-kit-step]').forEach(button => button.addEventListener('click', () => {
        input.value = clamp(clamp(input.value) + Number(button.dataset.kitStep));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      input.addEventListener('change', () => { input.value = clamp(input.value); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
